export default __webpack_public_path__ + "static/media/plus-outline.d925f838.svg";